import { requestGet, requestPut } from '../utils/requests';
import { API_BASE_URL } from '../containers/App/constants';
import { loadCabinetOrFurniture } from '../index';
import { getPNGimage } from '../containers/Viewer';

const URL_CABINETS_MISSING_IMG = `${API_BASE_URL}/cabinets_wt_image/`;
const URL_FURNITURES_MISSING_IMG = `${API_BASE_URL}/furnitures_wt_image/`;

function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function updateCabinetMissingImage(sleepDelay = 5000) {
  const cabinetsIds = await requestGet(URL_CABINETS_MISSING_IMG);

  for (const id of cabinetsIds as number[]) {
    loadCabinetOrFurniture(`${id}`);

    await sleep(sleepDelay);
    const image = getPNGimage();
    if (image) {
      const data = { id: id, image: image };
      await requestPut(URL_CABINETS_MISSING_IMG, data);
      console.log(`Update image of cabinet ${id}`);
    }
  }
}

export async function updateFurnitureMissingImage(sleepDelay = 10000) {
  const furnituresIds = await requestGet(URL_FURNITURES_MISSING_IMG);

  for (const id of furnituresIds as number[]) {
    loadCabinetOrFurniture(`f${id}`);

    await sleep(sleepDelay);
    const image = getPNGimage();
    if (image) {
      const data = { id: id, image: image };
      await requestPut(URL_FURNITURES_MISSING_IMG, data);
      console.log(`Update image of furniture f${id}`);
    }
  }
}
